// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__Y5hxN","mainContent":"Layout_mainContent__6OoEY"};